<template>
    <div class="d-flex align-items-center" v-if="isEdit">
        <b-button class="mr-2" variant="primary" @click="onSave">Save</b-button>
        <b-button variant="default" @click="onCancel">Cancel</b-button>
    </div>
</template>

<script>
import { paymentComponentMixin } from './mixin.js';

export default {
    name: 'NoneEdit',
    mixins: [paymentComponentMixin],
};
</script>

<style>
</style>